import { type ReactNode, Fragment } from 'react';
import { Button } from '../../atoms/Button';

export interface ModalFooterProps {
  children?: ReactNode;
  primaryLabel?: string;
  secondaryLabel?: string;
  primaryVariant?: 'primary' | 'danger' | 'success';
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  loading?: boolean;
  primaryDisabled?: boolean;
}

export function ModalFooter({
  children,
  primaryLabel,
  secondaryLabel = '취소',
  primaryVariant = 'primary',
  onPrimaryClick,
  onSecondaryClick,
  loading = false,
  primaryDisabled = false,
}: ModalFooterProps) {
  if (children) return children;

  return (
    <Fragment>
      {onSecondaryClick && (
        <Button variant="secondary" size="sm" onClick={onSecondaryClick} disabled={loading}>
          {secondaryLabel}
        </Button>
      )}
      {onPrimaryClick && (
        <Button
          variant={primaryVariant}
          size="sm"
          onClick={onPrimaryClick}
          loading={loading}
          disabled={primaryDisabled}
        >
          {primaryLabel}
        </Button>
      )}
    </Fragment>
  );
}
